import React,{Component} from "react";
import {AppBackground, MediumFont, TextColor, ThinBorder} from '../../styles/BaseStyles';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import MoneyCard from "./MoneyCard";
import TimeCard from "./TimeCard";
import Button from '@material-ui/core/Button';
import { shadows } from '@material-ui/system';
import { Link as RouterLink } from 'react-router-dom'
import Link from '@material-ui/core/Link';
import Typography from "@material-ui/core/Typography";
//Farshid
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
//import Button from '@material-ui/core/Button';
import {bindActionCreators} from "redux";
import {loginAction, saveAComment, updateUserProfileAction} from "../../redux/modules/login";
import {connect} from "react-redux";
import Divider from "@material-ui/core/Divider";
import TextField from "@material-ui/core/TextField";
import {DEFAULT_VESPAAN_SERVER} from "../../utils/MainConstants";
import Image from 'material-ui-image'
import * as MainConstants from "../../utils/MainConstants";
import ReactPlayer from 'react-player';

import CreditCardForm from "./CreditCardForm.js";

//import {updateUserProfileAction, saveAComment} from "../../redux/modules/login";
//import {bindActionCreators} from "redux";
//import {connect} from "react-redux";
//import {DEFAULT_VESPAAN_SERVER} from "../../utils/MainConstants";
//End Farshid



const Styles = theme => ({
  root: Object.assign({}, AppBackground, MediumFont),
  gridPane: {width: '50%', display: 'inline-block'},
  paneTable: {width: '100%', height: '100%',  backgroundColor:'grey'},
  videoPane: {width: '50%', display: 'inline-block', verticalAlign: 'top'},
  penInfoPanel: {color: 'white', fontSize: 20},
  penInfoPanelSelected: Object.assign({color: 'white', fontSize: 20}, ThinBorder),
  videoPanel: {marginTop: 0},
  penName: {color: TextColor, fontSize: 20, marginLeft: 10, cursor: 'pointer', display: 'inline-block'},
  metricValue: {display: 'inline-block', width: 100, height: 100, cursor: 'pointer'},
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridGap: `${theme.spacing.unit * 3}px`,
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  divider: {
    margin: `${theme.spacing.unit * 2}px 0`,
  },
  metricInfo: Object.assign({}, AppBackground, ThinBorder)

});

const styles = theme => ({
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridGap: `${theme.spacing.unit * 3}px`,
  },
  paper: {
    padding: theme.spacing.unit,
    textAlign: 'center',
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
    marginBottom: theme.spacing.unit,
  },
  divider: {
    margin: `${theme.spacing.unit * 2}px 0`,
  },
  leftPane: {width: '25%', height: '100%', verticalAlign: 'top', backgroundColor:'red'},
  rightPane: {fontSize: 40, color: 'black', verticalAlign: 'top', backgroundcolor:'red'},
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
  button: {
    margin: theme.spacing.unit,
  },
  extendedIcon: {
    marginRight: theme.spacing.unit,
  },
  margin: {
    margin: theme.spacing.unit * 2,
  },
  dividerColorPurpole: {
    //marginTop: theme.spacing.unit * 3,
    height: '20px',
    color:"#ffffff",
    //backgroundColor:"#760eb3",
  },

  multilineColor:{
    color:'black',
    backgroundColor:'#f5f7e8'
  }
});


class OrchimaCleanup extends Component {

  state = {
    age: '',
    name: 'hai',
    firstname: '',
    lastname:'',
    email:'',
    comment:'',
    userComment:{},
    selectedUser:{},
    showOrderForm:false
  };

  constructor(props) {
    super(props);

    this.handleFirstNameChange = this.handleFirstNameChange.bind(this);
    this.handleLastNameChange = this.handleLastNameChange.bind(this);
    this.handleEmailChange= this.handleEmailChange.bind(this);
    this.handleCommentChange = this.handleCommentChange.bind(this);
    this.saveVisitorComment = this.saveVisitorComment.bind(this);

    this.handleAddress2Change = this.handleAddress2Change.bind(this);
    this.handleShowOrderFormChange = this.handleShowOrderFormChange.bind(this);



  }


  componentDidMount() {
    const { isAuthenticated ,updateUserProfileAction} = this.props;
    //isAuthenticated();
    //updateUserProfileAction(this.props.userProfile, this.props.loginData.accessToken);
    updateUserProfileAction(null, this.props.loginData.accessToken);
    //updateAuth();
    // console.log("Farshid the loginData " + this.props.loginData.accessToken)  ;

  }


  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleShowOrderFormChange = event => {
    this.setState({ showOrderForm:!this.state.showOrderForm });
  };

  handleFirstNameChange(event) {
    //event.preventDefault();
    this.setState(Object.assign(this.state.userComment,{firstname:event.target.value}));

    //this.setState({userComment , {{firstname:event.target.value }});
    // this.setState(Object.assign(this.state.firstname, event.target.value));
  }

  handleLastNameChange(event) {
    //event.preventDefault();
    //this.setState(Object.assign(this.state.lastname, event.target.value));
    this.setState(Object.assign(this.state.userComment,{lastname:event.target.value}));

  }

  handleEmailChange(event) {
    //event.preventDefault();
    //this.setState(Object.assign(this.state.email,event.target.value));
    this.setState(Object.assign(this.state.userComment,{email:event.target.value}));

  }
  handleCommentChange(event) {
    //event.preventDefault();
    this.setState(Object.assign(this.state.userComment,{comment: event.target.value}));
  }


  saveVisitorComment(){
    const {saveAComment} = this.props;
    var  returnString="";
    var tempLastName =  this.state.userComment.lastname;
    var tempFirstName = this.state.userComment.firstname;
    var tempEmail = this.state.userComment.email;
    var tempComment = this.state.userComment.comment;


    if((tempFirstName == null) || (tempFirstName.length == 0)){
      alert("Please provide your first name!");
    }else {

      if ((tempLastName == null) || (tempLastName.length == 0)) {
        alert("Please provide your last name!");
      }else {

        if ((tempEmail == null) || (tempEmail.length == 0)) {
          alert("Please provide your Email!");
        } else {

          if ((tempEmail.indexOf("@") == -1)) {
            alert("Please provide proper Email address!");
          }else{
            if ((tempComment == null) || (tempComment.length == 0)) {
              alert("Please provide your comment!");
            }else{
              //Here send the data to the back end.
              saveAComment(DEFAULT_VESPAAN_SERVER.url, this.state.userComment);

            }
          }
        }
      }
    }

    return returnString;
  }

//Background color was backgroundColor:'#f4f3ed',

  handleAddress2Change(event) {
    //event.preventDefault();
    this.setState(Object.assign(this.state.selectedUser,{address2:event.target.value}));
  }



  render() {
    let shorOrderFormButtonText="";
    const { classes } = this.props;
    const MyLink = props => <RouterLink to="#top2" {...props} />
    if( !this.state.showOrderForm){
      shorOrderFormButtonText = "Show Order Form";
    }else{
      shorOrderFormButtonText = "Hide Order Form";
    }
    return (

      <div id="top1"  style={{  }}>
        <Grid container spacing={24}>

          <Grid   item xs={12} sm={12}  >

            <a href="/Home"   rel="noreferrer">
              <Typography component="h1" variant="h6" style = { { color:'blue', marginLeft:20}} >
                Back to Orchima Home
              </Typography>
            </a>
            <div style = { {textAlign: 'center', alignSelf: 'center', paddingTop:'200', marginBottom:'100',  marginTop:'200', width:'100%'}}>
              <Grid container spacing={24}>
                <Grid   item xs={1} sm={1}  >
                </Grid>
                <Grid   item   xs={12} sm={12}  md={5} lg={5}   xl={5}  >
                  <br/>
                  <Typography variant="h6" component="h2" style = { { textAlign: 'center', alignSelf: 'center'  , color:'#BF360C', fontSize:30}}>
                    Steps to Clean and Reassemble the {MainConstants.APPLICATION_NAME}&trade; Valve
                  </Typography >
                  <Typography  style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'black', }}>
                    Over time, fine particles from bark or growing media may collect inside the drainage holes or around the drainage valve.
                    When this happens, the valve may not close completely or the pot may not drain fully. If you notice that the {MainConstants.APPLICATION_NAME}&trade; pot
                    is not draining as expected, the drainage valve is likely partially blocked.

                  </Typography>
                  <br/>
                  <Typography  style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'black', }}>
                    To resolve this, remove the liner and screen filter, then thoroughly rinse the inside of the pot with clean water.
                    Pay special attention to the drainage holes and valve area to ensure any trapped debris is fully cleared.
                    Keeping the drainage path clean allows
                    the valve to close properly, ensures excess water drains completely, and helps the bark soak evenly as intended.
                    Also rinse the screen filter if you notice it has become clogged.

                  </Typography>
                  <br/>
                  <Typography  style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'black', }}>
                    Regularly rinsing away fine debris will prevent leaks, maintain proper drainage, and ensure your orchid
                    continues to receive the correct balance of moisture and airflow.

                  </Typography>
                  {/* To fix this issue, please follow the steps below:*/}
                  {/*}
                  <ol>
                    <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'black', }}>
                      Place the pot in an area where it can be safely drained.
                    </li>
                    <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'black', }}>
                      Do not remove the valve from the bottom of the {MainConstants.APPLICATION_NAME}&trade;.
                    </li>
                    <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'black', }}>
                      Disassemble the valve by twisting it until the white/translucent cap comes off.
                    </li>
                    <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'black', }}>
                      Inspect both pieces (as shown in the picture), wash them thoroughly, and ensure there is no debris inside the valve.
                    </li>
                    <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'black', }}>
                      Reassemble the valve by pushing and screwing the white/translucent cap back onto the main valve body.
                    </li>
                    <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'black', }}>
                      Reattach the valve to the bottom of the pot.
                    </li>
                    <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'black', }}>
                      Your {MainConstants.APPLICATION_NAME}&trade; is now ready for use again.
                    </li>
                  </ol>*/}



                </Grid>
                {/* These were pictures that I removed form this page for now}
                <Grid   item xs={12} sm={12}  md={5} lg={5}   xl={5}  style={{ marginRight:30, marginLeft:10, marginTop:10 ,  marginBotton:10, height:'20%'}} >

                  <div style={{paddingLeft:100, paddingBottom:10, paddingTop:20, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    <div  style={{   marginLeft:10, marginTop:10 ,  marginBotton:10, height:200, width:200  }}>
                      <Image
                          //src="/static/images/IMG_3615.JPG"
                          src="/static/images/IMG_7193.png"
                          aspectRatio='(3/4)'
                      />
                    </div>
                    <div  style={{   marginLeft:10, marginTop:100 ,  marginBotton:10, marginBotton:10,   width:200  }}>
                      <Image
                          //src="/static/images/IMG_3615.JPG"
                          src="/static/images/IMG_7193.png"
                          aspectRatio='(3/4)'
                      />
                    </div>
                  </div>

                </Grid>
                */}
                <Grid   item xs={1} sm={1}  >
                </Grid>
              </Grid>
            </div>
              <br/>
              <br/>
              <br/>
              <a href="/Home"   rel="noreferrer">
                <Typography component="h1" variant="h6" style = { { color:'blue', marginLeft:20}} >
                  Back to Orchima Home
                </Typography>
              </a>

              {/*<a href="/privacy"   rel="noreferrer" style={{paddingLeft:10, paddingBottom:20, display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                <Typography component="h2" variant="body1" style = { { color:'blue'}} >
                  Privacy Policy
                </Typography>
              </a>
              <a href="/Home"   rel="noreferrer" style={{paddingLeft:10, paddingBottom:20, display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                <Typography component="h2" variant="body1" style = { { color:'blue'}} >
                  FloraPot Home
                </Typography>
              </a>
            </div>*/}
          </Grid>
        </Grid>
      </div>



    );
  }
}

OrchimaCleanup.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return {
    isAuthenticatedBool: state.login.isAuthenticatedBool,
    userProfile: state.login.userProfile,
    loginData:state.login.loginData,

    //auth:state.login.loginData,
    //CompanyDeleteResponse:state.account.deleteCompanyResp,
    //CompanySaveResponse:state.account.saveCompanyResp,
    //locationsArray:state.location.locationsArray,
    //vcArray:state.videocontroller.vcArray,
    //camerasArray:state.camera.camerasArray,
    //errorCMsg:state.account.errorCMsg,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    //login:login,
    //handleAuthentication:handleAuthentication,
    //isAuthenticated:isAuthenticated,
    updateUserProfileAction:updateUserProfileAction,
    saveAComment:saveAComment,
    //updateAuth:updateAuth,

  }, dispatch);
};

//export default BiomassView;
//export default withStyles(styles)(AboutPlateWiz);




//export default withStyles(styles)(AppView);
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(OrchimaCleanup));
